import { render, staticRenderFns } from "./addPageCrmInvoice.vue?vue&type=template&id=5bd4db53&scoped=true&"
import script from "./addPageCrmInvoice.vue?vue&type=script&lang=js&"
export * from "./addPageCrmInvoice.vue?vue&type=script&lang=js&"
import style0 from "./addPageCrmInvoice.vue?vue&type=style&index=0&id=5bd4db53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd4db53",
  null
  
)

export default component.exports